var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        "actions-component",
        [
          _c("template", { slot: "description" }, [
            _vm._v(
              " Gestión de accesos de usuarios por región para los indicadores regionales Somos1 V2. "
            ),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "pa-4" },
        [_c("somos1-v2-user-region-access-component")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }